import React, { forwardRef, memo } from 'react';
import { PickerRef } from '@rc-component/picker/es/interface';
import { InputSizes, InputTypes } from '@lib/components/Input/enums';
import TimePicker from './TimePicker';
import styles from './DateTimePicker.module.scss';

type Props = {
  disabled?: boolean;
  endLabel?: string;
  hasError?: boolean;
  label?: string;
  name?: string;
  onChange: (v: string[]) => void;
  size?: InputSizes;
  startLabel?: string;
  value?: string[];
};

// Each picker carries its own floating label so both stay labeled when the
// row wraps into a column on narrow containers. Falls back to `label` on the
// start picker when no dedicated labels are passed.
const TimeRangePicker = forwardRef(
  (props: Props, ref: React.ForwardedRef<PickerRef>) => {
    const {
      disabled,
      endLabel,
      hasError,
      label,
      name,
      onChange,
      size = InputSizes.large,
      startLabel = label,
      value,
    } = props;

    const startValue = value && value[0] ? value[0] : undefined;
    const endValue = value && value[1] ? value[1] : undefined;

    const handleStartChange = (time: string | null | undefined) => {
      const newValue = [time || '', endValue || ''];
      onChange(newValue);
    };

    const handleEndChange = (time: string | null | undefined) => {
      const newValue = [startValue || '', time || ''];
      onChange(newValue);
    };

    return (
      <div className={styles.rangePickerRow}>
        <TimePicker
          disabled={disabled}
          hasError={hasError}
          label={startLabel}
          name={`${name}-start`}
          onChange={handleStartChange}
          ref={ref}
          size={size}
          type={InputTypes.time}
          value={startValue}
        />
        <TimePicker
          disabled={disabled}
          hasError={hasError}
          label={endLabel}
          name={`${name}-end`}
          onChange={handleEndChange}
          size={size}
          type={InputTypes.time}
          value={endValue}
        />
      </div>
    );
  },
);

export default memo(TimeRangePicker);
